export enum FOLKSONOMY {
    /**
     * @value Add tags...
     * @description Input's placeholder to add tags to a post
     */
    ADD = 'FRONT.TAGZ.ADD',
    /**
     * @value "%TAG%" is already added
     * @description Message display if current tag is already added
     */
    ALREADY_ADDED = 'FRONT.TAGZ.ALREADY_ADDED',
    /**
     * @value Create "%TAG_NAME%"
     * @description Displayed in the tagz autocomplete to invite the user to create the tag he is currently writing.
     */
    NEW_TAG = 'FRONT.TAGZ.CREATE.NEW_TAG',
    /**
     * @value Suggested tags:
     * @description Field displayed when tags are being suggested to the user (eg: the post dialog)
     */
    SUGGESTED_TAGS = 'FRONT.TAGZ.SUGGESTED_TAGS.TITLE',
    /**
     * @value Add tag %TAG%
     */
    ADD_TAG_ARIA_LABEL = 'FRONT.TAGZ.ADD_TAG.ARIA_LABEL',
}
